import { gql } from "lib/apolloClient";
import { externalCollaboratorFragment } from "Projects/modules/ProjectFragments";

export const addCollaboratorMutation = gql`
  mutation addUserV2($input: UserInputV2!) {
    platform {
      addUserV2(input: $input) {
        isSuccess
        warning
        user {
          ...externalUserItem
        }
      }
    }
  }
  ${externalCollaboratorFragment.basicExternalCollaborator}
`;

export const updateCollaboratorMutation = gql`
  mutation updateUserV2($input: UserUpdateInput!) {
    platform {
      updateUserV2(input: $input) {
        warning
        isSuccess
        user {
          ...externalUserItem
        }
      }
    }
  }
  ${externalCollaboratorFragment.basicExternalCollaborator}
`;

export const triggerCasExternalInviteEmailMutation = gql`
  mutation triggerCasEmail($input: SendCasExternalInviteEmailInput!) {
    documentation {
      sendCasExternalInviteEmail(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const portCasExternalOldData = gql`
  mutation portCasExternalData($input: PortCasExternalOldDataInput!) {
    documentation {
      portCasExternalOldData(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;
